import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const ImportProcessInfoBanner: React.FC = () => {
  return (
    <Box paddingBottom="s16">
      <F0Alert
        variant="info"
        title={i18n.t('universal_importer.import_history_process.info_banner.title')}
        description={i18n.t('universal_importer.import_history_process.info_banner.description')}
      />
    </Box>
  )
}
